import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {ApiResponse} from '../classes/api-response';
import {environment} from '../../environments/environment';
import {map} from 'rxjs/operators';
import {Box} from '../model/box';
import {HttpClient} from '@angular/common/http';
import {UtilsService} from "./utils.service";
import {Constants} from "../utils/constants";
import {Contract} from "../model/contract";
import {CreateBoxDTO} from '../model/dto/box/create-box-dto';

@Injectable({
  providedIn: 'root'
})
export class BoxesService {

  private readonly entities = Constants.entities;
  private readonly crtlPathFragment = this.entities.boxes;
  private readonly crtlFullPath = `${environment.apiUrl}/${this.crtlPathFragment}`;

  constructor(private http: HttpClient) {
  }

  public getAllBoxes(statuses?: string[]): Observable<Box[]> {
    const params = UtilsService.buildUrl(statuses);
    return this.http
      .get<ApiResponse>(`${this.crtlFullPath}`, { params })
      .pipe(map(value => value.data as Box[]));
  }

  public getAllBoxesByContract(contract?: Contract, statuses?: string[]): Observable<Box[]> {
    const params = UtilsService.buildUrl(statuses);
    return this.http
      .get<ApiResponse>(`${environment.apiUrl}/${this.entities.contracts}/${contract?.id}/${this.entities.boxes}?tests=true`, { params })
      .pipe(map(value => value.data as Box[]));
  }

  public getBox(id?: number | string, statuses?: string[]): Observable<Box> {
    const params = UtilsService.buildUrl(statuses);
    return this.http
      .get<ApiResponse>(`${this.crtlFullPath}/${id}`, { params })
      .pipe(map(value => value.data as Box));
  }

  public createBox(box: CreateBoxDTO): Observable<Box> {
    return this.http
      .post<ApiResponse>(`${this.crtlFullPath}`, box)
      .pipe(map(value => value.data as Box));
  }

  public createBoxInContract(box: Box, companyId?: number, contractId?: number): Observable<Box> {
    return this.http
      .post<ApiResponse>(`${environment.apiUrl}/${this.entities.contracts}/${contractId}/${this.entities.boxes}`, box)
      .pipe(map(value => value.data as Box));
  }

  public updateBox(box: Box, boxId?: number): Observable<void> {
    return this.http
      .patch<ApiResponse>(`${this.crtlFullPath}/${boxId}`, box)
      .pipe(map(() => { }));
  }

  public deleteBox(id: number): Observable<void> {
    return this.http
      .delete<ApiResponse>(`${this.crtlFullPath}/${id}`)
      .pipe(map(() => { }));
  }

  public associateBoxes(companyId?: number, boxes?: Box[], contractId?: number): Observable<void> {
    return this.http
      .put<ApiResponse>(`${environment.apiUrl}/${this.entities.contracts}/${contractId}/${this.entities.boxes}`, boxes)
      .pipe(map(() => { }));
  }

}
